import certificat from '../assets/icons/certificat-iso-14001.png'
import facebook from '../assets/icons/facebook.png'
import instagram from '../assets/icons/instagram.png'
import linkedin from '../assets/icons/linkedin.png'
import youtube from '../assets/icons/youtube.png'
import france from '../assets/icons/france.png'
import germany from '../assets/icons/germany.png'
import eur from '../assets/icons/eur.png'
import dakks from '../assets/dakks.png'
import { FiDownload } from "react-icons/fi";
import { IoChevronDown } from "react-icons/io5";
import wetekup from '../assets/icons/wetekup.png'
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [openSection, setOpenSection] = useState(null);

  const changeLanguage = (event) => {
    const selectedLang = event.target.value;
    i18n.changeLanguage(selectedLang);
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <footer className="w-full bg-gray-50 pt-12">
      {/* Mobile View - Accordion Style */}
      <div className="lg:hidden max-w-7xl mx-auto px-4">
        {/* DAkkS Logo */}
        <div className="flex items-center justify-center mb-8">
          <img src={dakks} alt='DAkkS Certificate' className="h-20 object-contain" />
        </div>

        {/* Support Section - Accordion */}
        <div className="border-b border-gray-300">
          <button
            onClick={() => toggleSection('support')}
            className="w-full flex items-center justify-between py-4 text-left"
          >
            <h3 className="text-gray-400 uppercase text-sm font-normal tracking-wider">
              {t('footer.support')}
            </h3>
            <IoChevronDown 
              className={`text-gray-400 transition-transform duration-300 ${openSection === 'support' ? 'rotate-180' : ''}`} 
              size={20} 
            />
          </button>
          {openSection === 'support' && (
            <div className="pb-4 space-y-2 text-gray-700 text-sm">
              <p className="cursor-pointer hover:text-primary">{t('footer.terms')}</p>
              <p className="cursor-pointer hover:text-primary">{t('footer.privacy')}</p>
              <p className="cursor-pointer hover:text-primary">{t('footer.delivery')}</p>
            </div>
          )}
        </div>

        {/* Coordinates Section - Accordion */}
        <div className="border-b border-gray-300">
          <button
            onClick={() => toggleSection('coordinates')}
            className="w-full flex items-center justify-between py-4 text-left"
          >
            <h3 className="text-gray-400 uppercase text-sm font-normal tracking-wider">
              {t('footer.coordinates')}
            </h3>
            <IoChevronDown 
              className={`text-gray-400 transition-transform duration-300 ${openSection === 'coordinates' ? 'rotate-180' : ''}`} 
              size={20} 
            />
          </button>
          {openSection === 'coordinates' && (
            <div className="pb-4 space-y-2 text-gray-700 text-sm">
              <p>{t('footer.address')}</p>
              <p>+33 (0) 6 18 14 54 74</p>
              <p>fournitest@gmail.com</p>
            </div>
          )}
        </div>

        {/* Documents Section - Accordion */}
        <div className="border-b border-gray-300">
          <button
            onClick={() => toggleSection('documents')}
            className="w-full flex items-center justify-between py-4 text-left"
          >
            <h3 className="text-gray-400 uppercase text-sm font-normal tracking-wider">
              {t('footer.document')}
            </h3>
            <IoChevronDown 
              className={`text-gray-400 transition-transform duration-300 ${openSection === 'documents' ? 'rotate-180' : ''}`} 
              size={20} 
            />
          </button>
          {openSection === 'documents' && (
            <div className="pb-4">
              <span
                onClick={() => window.open('https://fliphtml5.com/bookcase/sixxg/', '_blank')}
                className="flex items-center gap-2 text-gray-700 text-sm cursor-pointer hover:text-primary transition-colors"
              >
                <FiDownload size={16} /> {t('footer.catalogs')}
              </span>
            </div>
          )}
        </div>

        {/* Certifications Section - Accordion */}
        <div className="border-b border-gray-300">
          <button
            onClick={() => toggleSection('certifications')}
            className="w-full flex items-center justify-between py-4 text-left"
          >
            <h3 className="text-gray-400 uppercase text-sm font-normal tracking-wider">
              {t('footer.certifications')}
            </h3>
            <IoChevronDown 
              className={`text-gray-400 transition-transform duration-300 ${openSection === 'certifications' ? 'rotate-180' : ''}`} 
              size={20} 
            />
          </button>
          {openSection === 'certifications' && (
            <div className="pb-4">
              <img src={certificat} alt="ISO 14001 Certificate" className="h-16 object-contain" />
            </div>
          )}
        </div>

        {/* Language Selector */}
        <div className="flex justify-center my-8">
          <select 
            value={i18n.language} 
            onChange={changeLanguage}
            className="px-6 py-3 border-2 border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="fr">Français</option>
            <option value="en">English</option>
          </select>
        </div>

        {/* Country/Currency Flags */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src={france} alt="France" className="h-8 w-8 object-contain" />
          <img src={germany} alt="Germany" className="h-8 w-8 object-contain" />
          <img src={eur} alt="EUR" className="h-8 w-8 object-contain" />
        </div>

        {/* Social Media Icons */}
        <div className="flex items-center justify-center gap-3">
            <a href='#' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={facebook} alt="Facebook" className="h-6 w-6 object-contain" />
            </a>
            <a href='#' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={instagram} alt="Instagram" className="h-6 w-6 object-contain" />
            </a>
            <a href='https://www.linkedin.com/in/fathichaouachi/' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={linkedin} alt="LinkedIn" className="h-6 w-6 object-contain" />
            </a>
            <a href='#' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={youtube} alt="YouTube" className="h-6 w-6 object-contain" />
            </a>
          </div>
      </div>

      {/* Desktop View - Original Layout */}
      <div className="hidden lg:block max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* DAkkS Logo */}
          <div className="flex items-start justify-center md:justify-start">
            <img src={dakks} alt='DAkkS Certificate' className="h-24 object-contain" />
          </div>
          
          {/* Coordinates Section */}
          <div className="space-y-3">
            <h3 className="text-gray-400 uppercase text-xs font-normal mb-4 tracking-wider">
              {t('footer.coordinates')}
            </h3>
            <div className="space-y-2 text-gray-700 text-sm">
              <p>{t('footer.address')}</p>
              <p>+33 (0) 6 18 14 54 74</p>
              <p>fournitest@gmail.com</p>
            </div>
          </div>
          
          {/* Support Section */}
          <div className="space-y-3">
            <h3 className="text-gray-400 uppercase text-xs font-normal mb-4 tracking-wider">
              {t('footer.support')}
            </h3>
            <div className="space-y-2 text-gray-700 text-sm">
              <p className="cursor-pointer hover:text-primary">{t('footer.terms')}</p>
              <p className="cursor-pointer hover:text-primary">{t('footer.privacy')}</p>
              <p className="cursor-pointer hover:text-primary">{t('footer.delivery')}</p>
            </div>
            <div className="flex flex-col items-start gap-2 justify-start">
            <h3 className="text-gray-400 uppercase text-xs font-normal mr-4  tracking-wider">
              {t('footer.document')}
            </h3>
            <span
              onClick={() => window.open('https://fliphtml5.com/bookcase/sixxg/', '_blank')}
              className="flex items-center gap-2 text-gray-700 text-sm cursor-pointer hover:text-primary transition-colors"
            >
              <FiDownload size={16} /> {t('footer.catalogs')}
            </span>
          </div>
          </div>
          
          {/* Certifications Section */}
          <div className="space-y-3">
            <h3 className="text-gray-400 uppercase text-xs font-normal mb-4 tracking-wider">
              {t('footer.certifications')}
            </h3>
            <div>
              <img src={certificat} alt="ISO 14001 Certificate" className="h-20 object-contain" />
            </div>
          </div>
          
          {/* Language and Social Section */}
          <div className="space-y-4 flex flex-col items-center lg:items-end">
            {/* Language Selector */}
            <select 
              value={i18n.language} 
              onChange={changeLanguage}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option value="fr">Français</option>
              <option value="en">English</option>
            </select>
            
            {/* Country/Currency Flags */}
            <div className="flex items-center gap-2">
              <img src={france} alt="France" className="h-6 w-6 object-contain" />
              <img src={germany} alt="Germany" className="h-6 w-6 object-contain" />
              <img src={eur} alt="EUR" className="h-6 w-6 object-contain" />
            </div>
          </div>
        </div>
        
        {/* Social Media Icons - Desktop */}
        <div className="flex justify-end mb-6">
          <div className="flex items-center gap-3">
            <a href='#' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={facebook} alt="Facebook" className="h-6 w-6 object-contain" />
            </a>
            <a href='#' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={instagram} alt="Instagram" className="h-6 w-6 object-contain" />
            </a>
            <a href='https://www.linkedin.com/in/fathichaouachi/' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={linkedin} alt="LinkedIn" className="h-6 w-6 object-contain" />
            </a>
            <a href='#' target='_blank' rel="noreferrer" className="hover:opacity-70 transition-opacity">
              <img src={youtube} alt="YouTube" className="h-6 w-6 object-contain" />
            </a>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="flex mt-6 h-16 items-center justify-center border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-row items-center justify-center gap-3 text-gray-600 text-sm">
            <img src={wetekup} alt="WE TEKUP" className="h-5" />
            <span className="text-center font-normal text-gray-400">
              &copy; {new Date().getFullYear()} Fournitest. {t('footer.rights')} <a href="https://www.instagram.com/we_tekup/" target='_blank' rel="noreferrer" className="text-primary hover:underline">WE TEKUP</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
